<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="py-5 bg-trama bg-primary">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestro Bernabéu</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              ¿Sabías que el lugar más fotografiado de Madrid es el estadio Santiago Bernabéu? Es probable que no te
              hayas sorprendido, ya que no hay lugar con potencial que se te resista: si un restaurante, una exposición
              o una calle son tendencia, allá que vas smartphone en mano, dispuesto a captar el momento (y a dejar
              constancia de ello en tus perfiles sociales).
              <strong>¡Si te gusta visitar e inmortalizar lugares únicos,</strong> de esos que alcanzan muchos
              “megustas”, <strong>te recomendamos que sigas cada punto de esta ruta!</strong>
            </p>
          </div>
          <div class="col-12 mt-4">
            <img src="/img/icons/influencers.svg" alt="Planes especiales para influencers" class="mr-3" /><span
              class="text-black small"
              >Planes especiales para influencers</span
            >
          </div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">#meencanta</h2>
            <p class="subtitular z-index-up">
              <strong
                >Paisajes asombrosos, enclaves inesperados, montañas inalcanzables, cielos despejados y carreteras
                sinuosas entre prados verdes.</strong
              >
              ¡Dale un toque de #bellezanatural a tu galería de fotos con esta selección de lugares que quitan el hipo!
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta6/penalara.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Peñalara</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Sabías que la cumbre del
                      <a
                        href="https://www.sierranortemadrid.org/parque-nacional-la-sierra-del-guadarrama/"
                        target="_blank"
                        alt="Más información sobre Peñalara"
                        >Peñalara,</a
                      >
                      con 2.428 metros de altura, es el punto más alto de toda la Comunidad de Madrid? ¡De hecho,
                      <strong>se le conoce como “el techo de Madrid”!</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Las laderas de la montaña están cubiertas de distinta vegetación, dependiendo de la altitud. Entre
                      los 1.000 y los 1.300 metros hay robledales, y desde los 1.100 a los 2.000 metros el bosque
                      predominante es el pino silvestre.
                      <strong>¡No te puedes perder los entornos del circo y lagunas de origen glaciar!</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      El centro de visitantes del Parque Nacional se encuentra en el Puerto de Los Cotos, si bien pueden
                      realizarse distintas rutas, de distinta dificultad.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="5h" />
                  <icon-otono />
                  <icon-primavera />
                  <icon-aventureros />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Peñalara</h3>

                <p>
                  “De Madrid al cielo”... ¡pasando por su “techo”! ¿Conoces cuál es el punto más alto de la Comunidad?
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="5h" />
                  <icon-otono />
                  <icon-primavera />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta6/puente-presa.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Puente de la presa del Villar</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/Valle-Bajo-del-Lozoya"
                        target="_blank"
                        alt="Más información sobre la Presa del Villar"
                        >La Presa del Villar</a
                      >
                      es una de las grandes obras de ingeniería del Canal de Isabel II realizadas durante el siglo XIX.
                      De hecho,
                      <strong
                        >el embalse de El Villar el más antiguo de todo el sistema de embalses del Canal de Isabel
                        II.</strong
                      >
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-parejas />
                  <icon-familias />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Puente de la presa del Villar</h3>

                <p>
                  Montañas, un río serpenteante y un cielo despejado: ¡no necesitas filtros para hacer fotos
                  espectaculares!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-parejas />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta6/pico-de-la-miel.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Pico de la Miel en La Cabrera</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      La Sierra de la Cabrera es un conjunto granítico de unos 4 kilómetros de longitud y de origen
                      paleozoico y, debido a sus características, es
                      <strong
                        >uno de los lugares de la Comunidad de Madrid más frecuentado por los aficionados al montañismo
                        y al alpinismo.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/sierra-la-cabrera/"
                        target="_blank"
                        alt="Más información sobre El Pico de la Miel"
                        >El Pico de la Miel</a
                      >
                      es la cumbre más famosa de la Sierra de La Cabrera, ya que su perfil redondeado se ha convertido
                      en todo un símbolo de la zona. Si quieres alcanzarla sin practicar la escalada, existe un sendero
                      que permite llegar a la cima, desde donde es posible contemplar una espléndida panorámica del
                      entorno. Además, desde ahí también es posible continuar hasta el Cancho Gordo, la cumbre más alta
                      de la Sierra de La Cabrera.
                    </span>
                  </li>
                  <li>
                    <span>
                      Dato adicional: ¡en esta zona es posible avistar buitres!
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-4h" />
                  <icon-parejas />
                  <icon-aventureros />
                  <icon-otono />
                  <icon-primavera />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Pico de la Miel en La Cabrera</h3>

                <p>
                  ¡Sube a la Sierra de La Cabrera y disfruta de unas vistas espectaculares desde su cima!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-4h" />
                  <icon-parejas />
                  <icon-aventureros />
                  <icon-otono />
                  <icon-primavera />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta6/bosque-finlandes.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Bosque Finlandés y Presillas de Rascafría</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Sabías que el
                      <a
                        href="https://www.rascafria.org/turismo/paseos-rutas-y-excursiones/desde-rascafria-a-el-paular/"
                        target="_blank"
                        alt="Más información sobre el Bosque Finlandés"
                        >Bosque Finlandés</a
                      >
                      se denomina así porque
                      <strong
                        >en los años ‘80 se donaron especies de origen escandinavo como símbolo del hermanamiento entre
                        Helsinki y Rascafría?</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      En mitad del Bosque podrás visitar una antigua cabaña que se usaba como sauna, y un pequeño lago
                      con un antiguo embarcadero. ¡Una ruta mágica en la que observar abetos, chopos y abedules!
                    </span>
                  </li>
                  <li>
                    <span>
                      Antes de llegar a este bosque puedes ir a ver
                      <strong>el Monasterio de Santa María de El Paular,</strong> que puede visitarse durante todo el
                      año. Después, te recomendamos
                      <strong>proseguir tu ruta hacia las Presillas de Rascafría,</strong> unas piscinas naturales
                      controladas que se encuentran en el cauce del río Lozoya. Y si te apetece seguir caminando puedes
                      <strong>llegar hasta la cascada del Purgatorio,</strong> un salto de agua que te sorprenderá por
                      su belleza.
                    </span>
                  </li>
                  <li>
                    <span>No es posible acceder con animales de compañía.</span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-4h" />
                  <icon-familias />
                  <icon-culturetas />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Bosque Finlandés y Presillas de Rascafría</h3>

                <p>
                  Bosques frondosos, piscinas naturales y saltos de agua escondidos. Si buscas lugares “top”, ¡esta ruta
                  es para ti!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-4h" />
                  <icon-familias />
                  <icon-culturetas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta6/chorrera-de-litueros.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Chorrera de los Litueros (puerto de Somosierra)</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <strong
                        ><a
                          href="https://www.aytosomosierra.es/ven-a-conocernos/lugares-de-interes"
                          target="_blank"
                          alt="Más información sobre la Chorrera de los Litueros"
                          >Esta cascada,</a
                        ></strong
                      >
                      situada en el puerto de Somosierra,
                      <strong>es la más alta de la Comunidad de Madrid.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejos adicionales: No debes beber directamente del agua; El baño está prohibido; Sí se puede
                      acceder con mascotas, aunque debes recordar llevar atado a tu perro. En estos caminos es posible
                      encontrar fauna salvaje o ganado.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-otono />
                  <icon-primavera />
                  <icon-familias />
                  <icon-parejas />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Chorrera de los Litueros (puerto de Somosierra)</h3>
                <p>
                  ¿Tu muro de Instagram es una exposición de paisajes asombrosos? ¡Añade esta cascada a tu colección!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-otono />
                  <icon-primavera />
                  <icon-familias />
                  <icon-parejas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->

        <!--          Inicio "4" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top my-5 my-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up ">
                <img src="/img/rutas/ruta6/silla-gigante.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Silla gigante de Puebla de la Sierra</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="http://www.sierradelrincon.org/pdf/Folleto_Senda_115_Valle_de_los_Suenos.pdf"
                        target="_blank"
                        alt="Más información sobre La Sillga Gigante de Merira"
                        >La Silla gigante de Meira (Galicia),</a
                      >
                      de <strong>6 metros de altura,</strong> se ha instalado de forma permanente en los alrededores de
                      Puebla de la Sierra, en el Valle de los Sueños.
                    </span>
                  </li>
                  <li>
                    <span>
                      La silla <strong>se encuentra en el Valle de los Sueños, un museo al aire libre.</strong> Se trata
                      de un conjunto escultórico con una exposición permanente de artistas como Joaquín Manzano o Lucía
                      Loren.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-parejas />
                  <icon-culturetas />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Silla gigante de Puebla de la Sierra</h3>
                <p>
                  ¿Buscas lugares sorprendentes? ¡Una silla gigante en medio de las montañas no se ve todos los días!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal6 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-parejas />
                  <icon-culturetas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "4" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->

    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Peñalara">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¿Sabías que la cumbre del
                <a
                  href="https://www.sierranortemadrid.org/parque-nacional-la-sierra-del-guadarrama/"
                  target="_blank"
                  alt="Más información sobre Peñalara"
                  >Peñalara,</a
                >
                con 2.428 metros de altura, es el punto más alto de toda la Comunidad de Madrid? ¡De hecho,
                <strong>se le conoce como “el techo de Madrid”!</strong>
              </span>
            </li>
            <li>
              <span>
                Las laderas de la montaña están cubiertas de distinta vegetación, dependiendo de la altitud. Entre los
                1.000 y los 1.300 metros hay robledales, y desde los 1.100 a los 2.000 metros el bosque predominante es
                el pino silvestre.
                <strong>¡No te puedes perder los entornos del circo y lagunas de origen glaciar!</strong>
              </span>
            </li>
            <li>
              <span>
                El centro de visitantes del Parque Nacional se encuentra en el Puerto de Los Cotos, si bien pueden
                realizarse distintas rutas, de distinta dificultad.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Puente de la presa del Villar">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/Valle-Bajo-del-Lozoya"
                  target="_blank"
                  alt="Más información sobre la Presa del Villar"
                  >La Presa del Villar</a
                >
                es una de las grandes obras de ingeniería del Canal de Isabel II realizadas durante el siglo XIX. De
                hecho,
                <strong
                  >el embalse de El Villar el más antiguo de todo el sistema de embalses del Canal de Isabel II.</strong
                >
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Pico de la Miel en La Cabrera">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                La Sierra de la Cabrera es un conjunto granítico de unos 4 kilómetros de longitud y de origen paleozoico
                y, debido a sus características, es
                <strong
                  >uno de los lugares de la Comunidad de Madrid más frecuentado por los aficionados al montañismo y al
                  alpinismo.</strong
                >
              </span>
            </li>
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/sierra-la-cabrera/"
                  target="_blank"
                  alt="Más información sobre El Pico de la Miel"
                  >El Pico de la Miel</a
                >
                es la cumbre más famosa de la Sierra de La Cabrera, ya que su perfil redondeado se ha convertido en todo
                un símbolo de la zona. Si quieres alcanzarla sin practicar la escalada, existe un sendero que permite
                llegar a la cima, desde donde es posible contemplar una espléndida panorámica del entorno. Además, desde
                ahí también es posible continuar hasta el Cancho Gordo, la cumbre más alta de la Sierra de La Cabrera.
              </span>
            </li>
            <li>
              <span>
                Dato adicional: ¡en esta zona es posible avistar buitres!
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Bosque Finlandés y Presillas de Rascafría">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¿Sabías que el
                <a
                  href="https://www.rascafria.org/turismo/paseos-rutas-y-excursiones/desde-rascafria-a-el-paular/"
                  target="_blank"
                  alt="Más información sobre el Bosque Finlandés"
                  >Bosque Finlandés</a
                >
                se denomina así porque
                <strong
                  >en los años ‘80 se donaron especies de origen escandinavo como símbolo del hermanamiento entre
                  Helsinki y Rascafría?</strong
                >
              </span>
            </li>
            <li>
              <span>
                En mitad del Bosque podrás visitar una antigua cabaña que se usaba como sauna, y un pequeño lago con un
                antiguo embarcadero. ¡Una ruta mágica en la que observar abetos, chopos y abedules!
              </span>
            </li>
            <li>
              <span>
                Antes de llegar a este bosque puedes ir a ver
                <strong>el Monasterio de Santa María de El Paular,</strong> que puede visitarse durante todo el año.
                Después, te recomendamos <strong>proseguir tu ruta hacia las Presillas de Rascafría,</strong> unas
                piscinas naturales controladas que se encuentran en el cauce del río Lozoya. Y si te apetece seguir
                caminando puedes <strong>llegar hasta la cascada del Purgatorio,</strong> un salto de agua que te
                sorprenderá por su belleza.
              </span>
            </li>
            <li>
              <span>No es posible acceder con animales de compañía.</span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal
      id="modal5"
      centered
      scrollable
      size="lg"
      hide-footer
      title="Chorrera de los Litueros (puerto de Somosierra)"
    >
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <strong
                  ><a
                    href="https://www.aytosomosierra.es/ven-a-conocernos/lugares-de-interes"
                    target="_blank"
                    alt="Más información sobre la Chorrera de los Litueros"
                    >Esta cascada,</a
                  ></strong
                >
                situada en el puerto de Somosierra,
                <strong>es la más alta de la Comunidad de Madrid.</strong>
              </span>
            </li>
            <li>
              <span>
                Consejos adicionales: No debes beber directamente del agua; El baño está prohibido; Sí se puede acceder
                con mascotas, aunque debes recordar llevar atado a tu perro. En estos caminos es posible encontrar fauna
                salvaje o ganado.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--   Inicio Modal 6-->
    <b-modal id="modal6" centered scrollable size="lg" hide-footer title="Silla gigante de Puebla de la Sierra">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="http://www.sierradelrincon.org/pdf/Folleto_Senda_115_Valle_de_los_Suenos.pdf"
                  target="_blank"
                  alt="Más información sobre La Sillga Gigante de Merira"
                  >La Silla gigante de Meira (Galicia),</a
                >
                de <strong>6 metros de altura,</strong> se ha instalado de forma permanente en los alrededores de Puebla
                de la Sierra, en el Valle de los Sueños.
              </span>
            </li>
            <li>
              <span>
                La silla <strong>se encuentra en el Valle de los Sueños, un museo al aire libre.</strong> Se trata de un
                conjunto escultórico con una exposición permanente de artistas como Joaquín Manzano o Lucía Loren.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 6-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    // IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    // IconFoodies: () => import('../../components/iconos/IconFoodies'),
    // IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    // IconInvierno: () => import('../../components/iconos/IconInvierno'),
    IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones'),
    IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-50%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setTween('#fondo-puntos', {
          width: '60%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
